import { createContext, useCallback, useContext, useState } from "react";

const MessengerContext = createContext(null);

const MAX_WINDOWS = 3;

export function MessengerProvider({ children }) {
  const [windows, setWindows] = useState([]); // [{user, minimized}]

  const openWindow = useCallback((otherUser) => {
    if (!otherUser?.id) return;
    setWindows((prev) => {
      const existing = prev.find((w) => w.user.id === otherUser.id);
      if (existing) {
        return prev.map((w) => (w.user.id === otherUser.id ? { ...w, minimized: false } : w));
      }
      const next = [...prev, { user: otherUser, minimized: false }];
      if (next.length > MAX_WINDOWS) next.shift();
      return next;
    });
  }, []);

  const closeWindow = useCallback((userId) => {
    setWindows((prev) => prev.filter((w) => w.user.id !== userId));
  }, []);

  const toggleMinimize = useCallback((userId) => {
    setWindows((prev) => prev.map((w) => (w.user.id === userId ? { ...w, minimized: !w.minimized } : w)));
  }, []);

  return (
    <MessengerContext.Provider value={{ windows, openWindow, closeWindow, toggleMinimize }}>
      {children}
    </MessengerContext.Provider>
  );
}

export function useMessenger() {
  const ctx = useContext(MessengerContext);
  if (!ctx) throw new Error("useMessenger must be used inside <MessengerProvider>");
  return ctx;
}
